import React, { useState, useContext } from "react";
import { Link, withRouter } from "react-router-dom";
import { ArrowDropDown, AccountCircle } from '@material-ui/icons';
import { AppContext } from '../../context/appContext';
import { FlexRowDiv, DropdownMenu, Dropdown, DropdownContent, MenuContainer } from './menuStyle';
import axios from 'axios';

const UserMenuComponent = (props) => {
  const { CurrentUser, dispatch } = useContext(AppContext)
  const [ showDropdown, setShowDropdown ] = useState('hidden');

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      {/* { CurrentUser && 
        <Link style={{ textDecoration: 'none', marginRight: '10px' }} to="/tenants">
          <FlexRowDiv>
            Tenants
          </FlexRowDiv>
        </Link>
      } */}
      {CurrentUser ?
      <>
        <Dropdown onMouseEnter={() => {setShowDropdown('visible')}} onMouseLeave={() => {setShowDropdown('hidden')}}>
          <FlexRowDiv>
            <AccountCircle fontSize="medium" />
            <span style={{marginLeft: '8px'}}>{CurrentUser.firstname} {CurrentUser.lastname}</span>
            <ArrowDropDown fontSize="medium" />
          </FlexRowDiv>
          <DropdownContent style={{visibility: showDropdown}}>
            <MenuContainer>
              <DropdownMenu style={{textAlign:'right'}} onClick={() => {
                  props.history.push('/myaccount');
                  }}>
                  <span>My Account</span>
              </DropdownMenu>
              {CurrentUser.role === "admin" &&
                <>
                  <DropdownMenu style={{textAlign:'right'}} onClick={() => {
                      props.history.push('/usermanage');
                      }}>
                      <span>Manage User</span>
                  </DropdownMenu>  
                  <DropdownMenu style={{textAlign:'right'}} onClick={() => {
                      props.history.push('/createuser');
                      }}>
                      <span>Create User</span>
                  </DropdownMenu>
                </>
              }
            
                <DropdownMenu style={{textAlign:'right'}} onClick={() => {
                  dispatch({type: 'LOGOUT'});
                  document.location.href = '/';
                }}>
                    <span>Logout</span>
                </DropdownMenu>
            </MenuContainer>
          </DropdownContent>
        </Dropdown>
        <FlexRowDiv onClick={() => window.location = "mailto: escworkshelp@esc4.net?subject=Scorecard Question"}>
          <img src="/assets/images/help.png" alt="" style={{width: '30px', height: '30px', marginRight: '10px'}} />
          Help
        </FlexRowDiv>
      </>
      :
      <>
        <Link style={{ textDecoration: 'none', marginRight: '10px' }} to="/signin">
          <FlexRowDiv>
            Sign in
          </FlexRowDiv>
        </Link>
        <FlexRowDiv onClick={() => window.location = "mailto: escworkshelp@esc4.net?subject=Scorecard Question"}>
          <img src="/assets/images/help.png" alt="" style={{width: '30px', height: '30px', marginRight: '10px'}} />
          Help
        </FlexRowDiv>
      </>
      }
    </div>          
  );
}

export default withRouter(UserMenuComponent);

